import { DeviceTypes, Networks } from '@iotv/iotv-v3-types';
export const NWName = (p) => {
    const nwId = p.value;
    switch (nwId) {
        case Networks.AWS_LPWAN:
            return 'AWS';
        case Networks.Chirpstack:
            return 'CS';
        case Networks.Helium:
            return 'HE';
        case Networks.Interceptor:
            return 'INT';
        case Networks.ThingPark:
            return 'TP';
        case Networks.TTN_Community:
            return 'TTNC';
        case Networks.TTN_Enterprise:
            return 'TTNE';
        default:
            return nwId;
    }
};
/** @deprecated in favour of `readableDeviceName()` from `@iotv/core-services` */
export const DeviceTypeFormatter = (p) => {
    return DeviceTypes[p.value];
};
